<div class="container-fluid mt-5 pt-5">
    <div class="row">
      <div class="col">
        <h1 id="notAuthorizedInstruction1-Label">{{lblNotAuthorizedInstruction1}}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3 id="notAuthorizedInstruction2-Label">{{lblNotAuthorizedInstruction2}}</h3>
      </div>
    </div>
  </div>
  